<template>
  <div>
    <div>
      <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">
        <div class="row">
          <!--Created At Filter --->
          <div class="col-12 col-md-6">
            <label class="form-label">{{ $t('statistics.daterange_created_at') }}</label>
            <RangeDatePicker
              id="date-filter-picker"
              v-model="filters.dateRange"
              class="col-12 col-md-6 datesFilter"
              :placeholder="$t('optometry.leads.date_range')"/>
          </div>

          <!----->
        </div>
      </div>
      <v-server-table
        id="iframeLogoTable"
        ref="iframeLogoTable"
        name="iframeLogoTable"
        :columns="columns"
        :options="tableOptions"
        @filter="onFilterUpdate"
        @loading="isLoading = true"
        @loaded="onLoaded"
        @row-click="handleLogoClicked"
        @pagination="onPagination">

        <!--<span slot="beforeFilter">
          <span>
            <va-popover
              v-if="selectedLogoIds.length > 0"
              placement="left"
              :message="$t('iframe.actions.delete')">
              <span class="icon fa fa-trash-o clickable" @click.prevent="onClickDelete()"></span>
            </va-popover>
          </span>
        </span> -->
        <span slot="h__selectLogo">
          <span class="round">
            <input class="selectLogoCheckbox" type="checkbox" id="checkboxSelectAllLogos" :checked="selectAllLogos" @click="selectAllLogos = !selectAllLogos">
            <label class="selectLogoCheckbox" for="checkboxSelectAllLogos"></label>
          </span>
        </span>
        <span slot="selectLogo" slot-scope="props" >
        <span class="round">
            <input class="selectLogoCheckbox" type="checkbox" :id="`checkbox${props.row.id}`" :checked="selectedLogos[props.row.id]" @click="handleLogoSelected(props.row)">
            <label class="selectLogoCheckbox" :for="`checkbox${props.row.id}`"></label>
          </span>
      </span>
        <span slot="created_at" slot-scope="props">
          {{props.row.created_at | localTime('YYYY-MM-DD HH:mm')}}
        </span>

        <span slot="name" slot-scope="props">
          {{props.row.name || "N/A"}}
        </span>

        <span slot="preview" slot-scope="props">
          <img :src="props.row.logo" width="80px">
        </span>

        <span slot="client" slot-scope="props">
          {{props.row.client_id ? clientOptions.find(elem => elem.id === props.row.client_id).name : "N/A"}}
        </span>


        <!--<span slot="actions" slot-scope="props" class="w-100 d-flex justify-content-center">
          <va-popover :message="$t('iframe.actions.delete')" placement="top">
            <i class="report-action-icon fa fa-trash-o p-2 clickable" @click.prevent.stop="onClickDelete(props.row)"></i>
          </va-popover>
        </span>-->

        <!-- <span slot="lang" slot-scope="props">
          {{props.row.lang.toUpperCase() || "N/A"}}
        </span>

        <span slot="country" slot-scope="props">
          {{props.row.country.toUpperCase() || "N/A"}}
        </span> -->


      </v-server-table>
    </div>
    <ConfirmationModal v-if="showDeleteConfirmationModal"
                      :title="confirmationModalTitle"
                      :body="confirmationModalBody"
                      okClass="btn-danger"
                      @modal-confirmed="confirmDelete"
                      @modal-canceled="cancelDelete"
    >
    </ConfirmationModal>
  </div>
</template>

<script>

import RangeDatePicker from "@/components/common/RangeDatePicker";
import TableQueryMixin from "@/mixins/TableQueryMixin";
import ApiService from "@/api/ApiService";
import axios from "axios";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder";
import ConfirmationModal from "@/components/common/ConfirmationModal";
import {IframeService} from "@/api/IframeService";
// import IframeBlocksTableMixinVue from '@/mixins/IframeBlocksTableMixin.vue';

export default {
  components: {ConfirmationModal, LoadingPlaceholder, RangeDatePicker},
  mixins: [
    TableQueryMixin,
    // IframeBlocksTableMixinVue
  ],
  props: {
    showFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    querySearch: {
      type: String,
      required: false,
      default: null
    },
    customQueries: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      filters: {
        querySearch: '',
        dateRange: {
          start: null,
          end: null
        }
      },
      selectedLogo: null,
      selectedLogos: {},
      selectedLogoIds: [],
      selectAllLogos: false,
      isLoading: false,
      pageResourceIdentifier: 'logos',
      queryUrl: `${this.$store.state.iframe_server}v1/test-flow/logo/all`,
      columns: ['selectLogo', 'created_at', 'name', 'client', 'preview'],
      tableOptions: {
        orderBy:{
          column: 'created_at',
          ascending: false
        },
        saveState: true,
        storage: 'local',
        filterable: ['created_at'],
        sortable: ['created_at'],
        customFilters: ['start', 'end'],
        columnsClasses: {
          selectBlock: 'selectBlockClass',
          created_at: 'createdAtClass',
          preview: 'text-center',
          actions: 'w-100 d-flex justify-content-center'
        },
        headings: {
          created_at: this.$t('iframe.table_headings.created_at'),
          name: this.$t('iframe.table_headings.name'),
          preview: this.$t('iframe.logos-library.logo'),
          actions: this.$t('iframe.table_headings.actions'),
          client: this.$t('iframe.table_headings.client')
        }
      },
      showDeleteConfirmationModal: false,
      selectedLogoToDelete: null,
    }
  },
  mounted() {
    let dropdownList = this.$el.getElementsByClassName('VueTables__columns-dropdown')[0].lastElementChild
    dropdownList.removeChild(dropdownList.childNodes[0])
  },
  methods: {
    onLoaded: function() {
      this.selectAllLogos = false
      this.selectedLogos = {}
      const logos = this.getData()
      for (const logo of logos) {
        this.selectedLogos[logo.id] = false
      }
      this.isLoading = false
    },
    onPagination: function() {
      this.selectAllLogos = false
      this.selectedLogos = {}
    },
    onClickDelete: function(logo = null) {
      if(logo) {
        this.selectedLogoToDelete = logo
      }
      this.showDeleteConfirmationModal=true
    },
    getData: function() {
      return this.$refs.iframeLogoTable.data
    },
    reload: function () {
      this.$refs.iframeLogoTable.refresh()
    },
    confirmDelete: function(logo = null) {
        const multiple = this.selectedLogoToDelete === null
        let ids = multiple
          ? this.getSelectedLogosIds()
          : parseInt(this.selectedLogoToDelete.id)

        IframeService.deleteLogo(ids).then(res => {
          setTimeout(() => {
            if(multiple) {
              this.showToast(this.$t('iframe.logo_library.multiple_deleted', {nr: this.getSelectedLogosIds().length}), this.$store.state.successToastOptions)
            } else {
              this.showToast(this.$t('iframe.logo_library.deleted'), this.$store.state.successToastOptions)
            }
            this.reload()
          }, 500)
        }).catch(err => {
          setTimeout(() => {
            let keys = Object.keys(err.response.data.errors)
            for (let key of keys) {
              let errorMessages = err.response.data.errors[key].map(errors => errors)
              if (errorMessages.some(msg => msg.replaceAll(' ','_').toLowerCase() === 'cannot_delete_noise_item(s)_that_are_assigned_to_hearing_test(s)')) {
                this.showToast(this.$t('iframe.logo_library.error_item_used'), this.$store.state.errorToastOptions)
              } else {
                this.showToast(this.$t('iframe.logo_library.delete_error'), this.$store.state.errorToastOptions)
              }
            }
          })
        }).finally(() => {
          this.showDeleteConfirmationModal = false
          this.selectAllLogos = false
          this.selectedLogos = {}
          const logos = this.getData()
          for (const logo of logos) {
            this.selectedLogos[logo.id] = false
          }
          this.selectedLogoToDelete = null
        })

    },

    cancelDelete: function () {
      this.showDeleteConfirmationModal = false
      this.selectedLogoToDelete = null
    },

    handleLogoClicked: function({event, row}) {
      if(event.srcElement.className ==="selectLogoCheckbox") {
        event.stopPropagation()
      } else {
        let selectedLogo = row
        // const entity = this.entities.filter(entity => entity.id === row.client_id)[0]
        // selectedLogo.client = entity ? entity : null
        this.$emit('logoClicked', selectedLogo)
        // this.$router.push(`/${this.iframeService.slug}/${this.iframeService.slug}/blocks-builder/${this.blockTypeIdentifier}/${row.id}`)
      }
    },
    handleLogoSelected: function (logo) {
      this.selectedLogos[logo.id] = !this.selectedLogos[logo.id]
      this.selectedLogoIds = this.getSelectedLogosIds()
    },
    getSelectedLogosIds: function () {
      const keys = Object.keys(this.selectedLogos)
      let selectedLogosIds = keys.filter(key => this.selectedLogos[key] === true)
      for(let elem of selectedLogosIds) {
        elem = parseInt(elem)
      }
      return selectedLogosIds
    },
  },
  watch: {
    selectAllLogos: function(value) {
      const keys = Object.keys(this.selectedLogos)
      for (const key of keys) {
        this.selectedLogos[key] = value
      }
      this.selectedLogoIds = this.getSelectedLogosIds()
    },
  },
  computed: {
    confirmationModalTitle: function(){
      return this.selectedLogoToDelete !== null ? this.$t('iframe.logo_library.delete_item_title') : this.$t('iframe.logo_library.delete_multiple_items_title')
    },
    confirmationModalBody(){
      return this.selectedLogoToDelete !== null
        ? this.$t('iframe.logo_library.delete_item_body', {name: this.selectedLogoToDelete.name})
        : this.$t('iframe.logo_library.delete_multiple_items_body', {nr: this.getSelectedLogosIds().length})
    },
    entities: function () {
      if (this.iframeService) {
        return this.iframeService.entities
      }
      return null
    },
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    clientOptions: function () {
      if (this.iframeService) {
        if (this.iframeService.user_permissions.some(perm => perm.entity_id === null)) {
          return this.iframeService.entities
        }
        const consideredEntitiesIds = this.iframeService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 120).map(elem => elem.entity_id)
        return this.iframeService.entities.filter(entity =>  consideredEntitiesIds.includes(entity.id))
      }
      return []
    },
  }
}
</script>

<style>
#iframeLogoTable .VueTables__search {
  justify-content: space-between;
  float:none !important;
}
.table-hover tbody tr:hover{
  background: rgba(41, 196, 170, 0.5) !important;
}
.selectBlockClass{
  width: 50px;
}
.createdAtClass {
  width: 300px;
}
</style>
<style scoped>

.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 1.375rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 1.375rem;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 5px;
  opacity: 0;
  position: absolute;
  top: 6px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #29c4a9;
  border-color: #29c4a9;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

</style>
